export const getProgressClosingDelay = (startedAt, minimumDurationInMs, completionDurationInSeconds) => {
  const remainingMinimum = minimumDurationInMs - (Date.now() - startedAt)

  return Math.max(remainingMinimum, completionDurationInSeconds * 1000)
}

export const wait = delayInMs => new Promise(resolve => setTimeout(resolve, delayInMs))
